import { types } from "./types";

export const resetProduct = () => ({
  type: types.RESET_PRODUCT
});

export const setQty = payload => ({
  type: types.SET_PRODUCT_QTY,
  payload
});

export const setPickedOptionSelections = payload => ({
  type: types.SET_PRODUCT_PICKED_OPTION_SELECTIONS,
  payload
});

export const setAvailableOptions = payload => ({
  type: types.SET_PRODUCT_AVAILABLE_OPTIONS,
  payload
});

export const setCustomAttributes = payload => ({
  type: types.SET_PRODUCT_CUSTOM_ATTRIBUTES,
  payload
});

export const updateProductSelectionQty = payload => ({
  type: types.UPDATE_PRODUCT_SELECTION_QTY,
  payload
});

export const updateProductSelectionTargetPrice = payload => ({
  type: types.UPDATE_PRODUCT_SELECTION_TARGET_PRICE,
  payload
});

export const updateProductSelectionFinanceType = payload => ({
  type: types.UPDATE_PRODUCT_SELECTION_FINANCE_TYPE,
  payload
});

export const addProductSelection = payload => ({
  type: types.ADD_PRODUCT_SELECTION,
  payload
});

export const deleteProductSelection = payload => ({
  type: types.DELETE_PRODUCT_SELECTION,
  payload
});

export const setSubscriptionTargetChargeValue = payload => ({
  type: types.SET_PRODUCT_SUBSCRIPTION_TARGET_CHARGE_VALUE,
  payload
});

export const setSubscriptionUserNum = payload => ({
  type: types.SET_PRODUCT_SUBSCRIPTION_USER_NUM,
  payload
});

export const setSubscriptionTerm = payload => ({
  type: types.SET_PRODUCT_SUBSCRIPTION_TERM,
  payload
});

export const setCcBw = payload => ({
  type: types.SET_PRODUCT_CC_BW,
  payload
});

export const setCcColour = payload => ({
  type: types.SET_PRODUCT_CC_COLOUR,
  payload
});

export const setScanCharge = payload => ({
  type: types.SET_PRODUCT_SCAN_CHARGE,
  payload
});

export const setDefaultCcBw = payload => ({
  type: types.SET_PRODUCT_DEFAULT_CC_BW,
  payload
});

export const setDefaultCcColour = payload => ({
  type: types.SET_PRODUCT_DEFAULT_CC_COLOUR,
  payload
});

export const setUserClickVolumeBw = payload => ({
  type: types.SET_PRODUCT_USER_CLICK_VOLUME_BW,
  payload
});

export const setUserClickVolumeColour = payload => ({
  type: types.SET_PRODUCT_USER_CLICK_VOLUME_COLOUR,
  payload
});

export const setDefaultScanCharge = payload => ({
  type: types.SET_PRODUCT_DEFAULT_SCAN_CHARGE,
  payload
});

export const setHasFallbackCcBw = payload => ({
  type: types.SET_HAS_FALLBACK_CC_BW,
  payload
});

export const setHasFallbackCcColour = payload => ({
  type: types.SET_HAS_FALLBACK_CC_COLOUR,
  payload
});

export const setMsaMetroCcBw = payload => ({
  type: types.SET_PRODUCT_MSA_METRO_CC_BW,
  payload
});

export const setMsaMetroCcColour = payload => ({
  type: types.SET_PRODUCT_MSA_METRO_CC_COLOUR,
  payload
});

export const setMsaRegionalCcBw = payload => ({
  type: types.SET_PRODUCT_MSA_REGIONAL_CC_BW,
  payload
});

export const setMsaRegionalCcColour = payload => ({
  type: types.SET_PRODUCT_MSA_REGIONAL_CC_COLOUR,
  payload
});

export const setScanningMonthlyCharge = payload => ({
  type: types.SET_PRODUCT_SCANNING_MONTHLY_CHARGE,
  payload
});

export const setDefaultScanningMonthlyCharge = payload => ({
  type: types.SET_PRODUCT_DEFAULT_SCANNING_MONTHLY_CHARGE,
  payload
});

export const setNzScanningMonthlyCharge = payload => ({
  type: types.SET_PRODUCT_NZ_SCANNING_MONTHLY_CHARGE,
  payload
});

export const setDefaultNzScanningMonthlyCharge = payload => ({
  type: types.SET_PRODUCT_DEFAULT_NZ_SCANNING_MONTHLY_CHARGE,
  payload
});

export const setFlatMonthlyCharge = payload => ({
  type: types.SET_PRODUCT_FLAT_MONTHLY_CHARGE,
  payload
});
export const setDefaultFlatMonthlyCharge = payload => ({
  type: types.SET_PRODUCT_DEFAULT_FLAT_MONTHLY_CHARGE,
  payload
});

export const setflatMonthlyChargeModifyable = payload => ({
  type: types.SET_PRODUCT_FLAT_MONTHLY_CHARGE_MODIFIABLE,
  payload
});

export const setCampaign = payload => ({
  type: types.SET_PRODUCT_CAMPAIGN,
  payload
});

export const addCampaign = payload => ({
  type: types.ADD_PRODUCT_CAMPAIGN,
  payload
});

export const setMsaTerm = payload => (dispatch, getState) => {
  const { product } = getState();
  const { msaDefaultTerm, msaDefaultCfa } = product;

  dispatch({
    type: types.SET_PRODUCT_MSA_TERM,
    payload
  });

  if (Number(payload) === msaDefaultTerm) {
    dispatch({
      type: types.SET_PRODUCT_MSA_CFA,
      payload: msaDefaultCfa
    });
  }
};

export const setMsaDefaultTerm = payload => ({
  type: types.SET_PRODUCT_MSA_DEFAULT_TERM,
  payload
});

export const setMsaCfa = payload => ({
  type: types.SET_PRODUCT_MSA_CFA,
  payload
});

export const setMsaDefaultCfa = payload => ({
  type: types.SET_PRODUCT_MSA_DEFAULT_CFA,
  payload
});

export const setMsaMdsCost = payload => ({
  type: types.SET_PRODUCT_MSA_MDS_COST,
  payload
});

export const setMsaDefaultMdsCost = payload => ({
  type: types.SET_PRODUCT_MSA_DEFAULT_MDS_COST,
  payload
});

export const setMsaPriceFlag = payload => ({
  type: types.SET_PRODUCT_MSA_PRICE_FLAG,
  payload
});

export const setMsaPayableMethod = payload => ({
  type: types.SET_PRODUCT_MSA_PAYABLE_METHOD,
  payload
});

export const setMsaInstalmentFrequency = payload => ({
  type: types.SET_PRODUCT_MSA_INSTALMENT_FREQUENCY,
  payload
});

export const setMinimumMonthlyCharge = payload => ({
  type: types.SET_PRODUCT_MINIMUM_MONTHLY_CHARGE,
  payload
});
export const setDefaultMinimumMonthlyCharge = payload => ({
  type: types.SET_PRODUCT_DEFAULT_MINIMUM_MONTHLY_CHARGE,
  payload
});

export const setMinimumMonthlyChargeModifiable = payload => ({
  type: types.SET_PRODUCT_MINIMUM_MONTHLY_CHARGE_MODIFIABLE,
  payload
});

export const setTonerDeliveryCharge = payload => ({
  type: types.SET_PRODUCT_TONER_DELIVERY_CHARGE,
  payload
});
export const setDefaultTonerDeliveryCharge = payload => ({
  type: types.SET_PRODUCT_DEFAULT_TONER_DELIVERY_CHARGE,
  payload
});

export const setPerA3Charge = payload => ({
  type: types.SET_PRODUCT_PER_A3_CHARGE,
  payload
});
export const setDefaultPerA3Charge = payload => ({
  type: types.SET_PRODUCT_DEFAULT_PER_A3_CHARGE,
  payload
});

export const setSaasFinanceType = payload => ({
  type: types.SET_PRODUCT_SAAS_FINANCE_TYPE,
  payload
});

export const setSaasExistingTenant = payload => ({
  type: types.SET_PRODUCT_SAAS_EXISTING_TENANT,
  payload
});
